<template>
  <el-table-column
    prop="related_docket"
    label="Előzmény"
    show-overflow-tooltip
    min-width="180"
  >
    <template slot-scope="scope">
      <span v-if="scope.row.related_docket && scope.row.related_docket.document_type">
        {{ `POP - ${scope.row.related_docket.id} (${scope.row.related_docket.document_type.name})` }}
      </span>
      <span v-else>-</span>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'related_docket',
  };
</script>
